import isBlank from "@sedan-utils/is-blank";
import { Input } from "antd";
import React from "react";
import style from "./StickieNode.module.css";
export var Stickie = function Stickie(props) {
  var _props$textAreaValue;
  var content = ((_props$textAreaValue = props.textAreaValue) === null || _props$textAreaValue === void 0 || (_props$textAreaValue = _props$textAreaValue[0]) === null || _props$textAreaValue === void 0 || (_props$textAreaValue = _props$textAreaValue.results) === null || _props$textAreaValue === void 0 || (_props$textAreaValue = _props$textAreaValue[0]) === null || _props$textAreaValue === void 0 ? void 0 : _props$textAreaValue.content) || "";
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(style["custom-node"], " ").concat(props.isLongPress || props.checkNodeArr.includes(props.id) ? "nowheel nopan" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(props.isLongPress ? "nodrag" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(style["input-mask"], " ").concat(props.isLongPress ? style["hidden-mask"] : ""),
    onClick: props.clickSelect
  }, !props.isLongPress && (isBlank(content) || typeof content === "string") ? /*#__PURE__*/React.createElement("p", {
    className: "".concat(style["alternate-text"], " ").concat(isBlank(content) ? style["place-color"] : "")
  }, content || props.placeholder) : null), /*#__PURE__*/React.createElement(Input.TextArea, {
    className: "".concat(!props.isLongPress ? "hidden-input" : ""),
    value: content,
    ref: props.inputRef,
    onPressEnter: props.onTextAreaEnter,
    onChange: function onChange(e) {
      return props.changeInputContent(e);
    },
    onBlur: props.onTextAreaBlur,
    onFocus: props.onTextAreaFocus,
    placeholder: props.placeholder,
    autoSize: true
  })));
};
export default Stickie;